<template>
  <article class="fullpage">
    <resources />
  </article>
</template>

<script>
import { resources } from '@/components/advisor';
import getBrandConfig from '@/lib/utils/get_brand_config';

const brandConfig = getBrandConfig();

export default {
  head() {
    const title = this.$t('Resources');
    return {
      title: `${title} | ${brandConfig.fullName}`,
    };
  },
  components: { resources },
};
</script>
